import {AccountBasicInfo, ApiSingleResponseBase} from '../../types';
import {Observable} from 'rxjs';
import {marineHubAPI} from '../provider/marineHubAPI';
import {RestQueryParams} from '../base/queryParams';

export function changeLocaleAPI(accountId: string, locale: any): Observable<ApiSingleResponseBase<AccountBasicInfo>> {
    return marineHubAPI.put(`api/accounts/${accountId}/change_locale`, {locale}, new RestQueryParams());
}
